import React from 'react'
import Styles from "./PunctualityScreen.module.css"
//import Punctuality from "../fakeDB/Punctuality";
import Confetti from './Confetti'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../componentes/DateUtilities'
import PageLoader from '../../componentes/pageLoader/pagelLoader'
import ComponentLoader from '../../componentes/componentLoader/componentLoader'
import {getCompanyCollection} from '../../firebase'


class EmployeeWeekScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            loaderVisible: Styles.visible,
            pageVisible: Styles.hidden,
            profilePic: Styles.hidden,
            profilePicLoader: Styles.visible,
            name: '',
            image: '',
            list: [],
            i: 1,
            nextScreen: 'ActivitiesScreen',
            sendNextPage: () => {
                this.props.nextPageProp(this.state.nextScreen);
            },
        }
        this.nextUrl = ''
        this.peopleUrl=''
        this.peopleImgLoaded = false
    }

    componentDidMount() {
        console.log('puntuality')
        this.getData()
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    getImgsUrls=async()=>{
        const promise1=firebase.storage().ref().child('images/site-pics/people.png').getDownloadURL()
        const promise2=firebase.storage().ref().child('images/site-pics/avatar1.png').getDownloadURL()
        const promise3=firebase.storage().ref().child('images/site-pics/avatar2.png').getDownloadURL()
        this.peopleUrl=await promise1
        this.femaleUrl=await promise2
        this.maleUrl=await promise3
    }
    getData = async () => {
        try {
            await this.getImgsUrls()
            //this.nextUrl = (await firebase.firestore().collection('Info').doc('teleLink').get()).data().link
            const thisThursday = DateUtilities.getThursdayDate(DateUtilities.today())
            const lastThursday = DateUtilities.addDays(thisThursday, -7)
            const snapshot = await firebase.firestore().collection('EmpleadosSemana')
                .where('fecha', '>=', lastThursday)
                .where('fecha', '<', thisThursday)
                .get()
            const list = []
            for (let i = 0; i < snapshot.docs.length; i++) {
                if (!snapshot.docs[i].exists) break
                const employeeWeek = snapshot.docs[i].data()
                const employeeSnap = await (await getCompanyCollection('Empleados')).where('Nombre', '==', employeeWeek.nombre).get()
                if(employeeSnap.empty){
                    console.log(`No existe el empleado ${employeeWeek.nombre}`)
                    continue
                }
                const employee = employeeSnap.docs[0].data()
                let img = ''
                try{
                    img=await firebase.storage().ref().child(`images/profile-pics/${employee.foto}.jpg`).getDownloadURL()
                    console.log(img)
                }
                catch(e){
                    console.log(e)
                    img = employee.genero === 'masculino' ? this.maleUrl : this.femaleUrl
                }
                list.push({
                    name: employee.Nombre,
                    image: img,
                })
            }
            if (list.length === 0) return this.state.sendNextPage() //window.location.replace(this.nextUrl)
            this.setState({
                dataLoaded: true,
                list: list,
                name: list[0].name,
                image: list[0].image,
            })
        }
        catch (e) {
            console.log(e.message)
            if (e.message === 'Failed to get document because the client is offline.') {
                return this.getData()
            }
            this.state.sendNextPage()
        }
    }
    setTimer = () => {
        this.interval = setInterval(() => {
            if (this.state.i < this.state.list.length) {
                this.setState({
                    name: this.state.list[this.state.i].name,
                    image: this.state.list[this.state.i].image,
                    i: this.state.i + 1,
                    profilePic: Styles.hidden,
                    profilePicLoader: Styles.visible,

                })

            } else if (this.state.i >= this.state.list.length) {
                //this.setState({ i: 0 })
                this.state.sendNextPage();
                //window.location.replace(this.nextUrl)
            }
        }, 8000)
    }
    handleLoad = () => {
        if(!this.state.dataLoaded) return null
        this.peopleImgLoaded = true
        this.isPageLoaded()
    }
    handleProfilePicLoad = () => {
        this.setState({
            profilePicLoader: Styles.hidden,
            profilePic: Styles.visible,
        })
    }
    isPageLoaded = () => {
        if (this.peopleImgLoaded && this.state.dataLoaded) {
            this.setState({
                pageVisible: Styles.visible,
                loaderVisible: Styles.hidden,
            })
            this.setTimer()
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.list !== this.state.list) {
            this.isPageLoaded()
        }
    }
    render() {
        return (
            <>
                <PageLoader className={this.state.loaderVisible} />
                <div className={`${Styles.mainconteiner} ${Styles.rows} ${this.state.pageVisible}`}>
                    <Confetti width="100%" height="100%"></Confetti>
                    <div className={`${Styles.item1} ${Styles.container}`}>
                        <div className={`${Styles.griditem} ${Styles.container} ${Styles.centercontent} ${Styles.centeritems} ${Styles.justifycenter}`} >
                            <span className={`${Styles.title}`}>Empleado de la semana</span>
                        </div>
                    </div>
                    <div className={`${Styles.item2} ${Styles.container} ${Styles.cols}`}>
                        <div className={`${Styles.griditem} ${Styles.container}`}></div>
                        <div className={`${Styles.griditem} ${Styles.container} ${Styles.cols} ${Styles.grow}`}>
                            <div className={`${Styles.frame} ${Styles.griditem} ${Styles.container} ${Styles.centercontent} ${Styles.centeritems} ${Styles.justifycenter}`}>
                                <ComponentLoader className={this.state.profilePicLoader} />
                                <img src={this.state.dataLoaded? this.state.image :''} alt="" className={`${Styles.image} ${this.state.profilePic}`} onLoad={this.handleProfilePicLoad} onError={this.handleProfilePicLoad} />
                            </div>
                            <div className={`${Styles.frame2} ${Styles.griditem} ${Styles.container} ${Styles.centercontent} ${Styles.centeritems} ${Styles.justifycenter} ${Styles.rows}`}>
                                <div className={`${Styles.griditem} ${Styles.container} ${Styles.alingdown}`}>
                                    <span className={`${Styles.title2}`}>!Gracias¡</span>
                                </div>
                                <div className={`${Styles.griditem} ${Styles.container} ${Styles.centeritems} ${Styles.alingcenter}`}>
                                    <span className={`${Styles.name}`}>{this.state.name}</span>
                                </div>
                                <div className={`${Styles.griditem} ${Styles.container}`}>
                                    <span className={`${Styles.content}`}>Por tu constancia y disiplina.</span>
                                </div>
                            </div>
                        </div>
                        <div className={`${Styles.griditem} ${Styles.container}`}></div>

                    </div>
                    <div className={`${Styles.item3} ${Styles.container} ${Styles.alingdown} ${Styles.applause}`}>
                        <img src={this.state.dataLoaded? this.peopleUrl :''} alt="people" className={`${Styles.people}`} onLoad={() => { this.handleLoad() }} onError={this.handleLoad}/>
                    </div>
                </div>
            </>
        )
    }
}

export default EmployeeWeekScreen;
